export default __webpack_public_path__ + "static/media/AE8.eca2ef12.jpg";